<template>
  <div class="twind">
    <template v-if="designType === 'tabs' || !designType">
      <ReviewTabs
          :tabs="tabs"
          :active-tab="activeTab"
          :overall-rating="overallStarRating"
          @change-tab="changeTab"
      />
      <ReviewContent
          :active-tab="activeTab"
          :tabs="tabs"
          :all-reviews="allReviews"
          :overall-rating="overallStarRating"
      />
    </template>

    <template v-else-if="designType === 'no-tabs'">
      <ReviewContent
          :active-tab="-1"
          :tabs="tabs"
          :all-reviews="allReviews"
          :overall-rating="overallStarRating"
          :show-tabs="false"
      />
    </template>

    <template v-else-if="designType === 'badge'">
      <ReviewBadge
          :overall-rating="overallStarRating"
          :all-reviews="allReviews"
      />
    </template>

    <template v-else-if="designType === 'carousel'">
      <ReviewCarousel
          :overall-rating="overallStarRating"
          :reviews="allReviews"
      />
    </template>

  </div>
</template>

<script>
import ReviewTabs from './components/ReviewTabs.vue'
import ReviewContent from './components/ReviewContent.vue'
import ReviewBadge from './components/ReviewBadge.vue'
import ReviewCarousel from "@/components/widgets/all-in-one-reviews/components/ReviewCarousel.vue";
import axios from "axios";

export default {
  name: 'ReviewsWidget',
  components: {
    ReviewTabs,
    ReviewContent,
    ReviewBadge,
    ReviewCarousel
  },
  props: ['widgetId'], // Add designType prop
  data() {
    return {
      activeTab: -1,
      tabs: [],
      overallStarRating: 0,
      allReviews: [],
      designType: 'tabs'
    };
  },
  mounted() {
    this.fetchTabData();
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },
    async fetchTabData() {
      console.log(this.widgetId)

      // Example API response structure
      let rawApiResponse = await axios.get(process.env.VUE_APP_API_URL + '/api/widget/' + this.widgetId);
      let apiResponse = rawApiResponse.data;

      if (apiResponse.template) this.designType = apiResponse.template;
      this.tabs = apiResponse.tabs;
      this.overallStarRating = apiResponse.overallStarRating;

      let randomisedReviews = this.shuffleArray(apiResponse.allReviews);
      this.allReviews = randomisedReviews;
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }

      return array;
    }
  }
};
</script>

<style scoped>
/* Styles remain the same */
.review-tab-active {
  background: #9e9fa0;
}
</style>